import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-verticalcentersnap",
  "use": "icon-verticalcentersnap-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-verticalcentersnap\"><path d=\"M102.4 486.4l102.4 0 0 51.2-102.4 0 0-51.2Z\" p-id=\"4424\" /><path d=\"M512 486.4l409.6 0 0 51.2-409.6 0 0-51.2Z\" p-id=\"4425\" /><path d=\"M563.2 332.8l256 0 0 358.4-256 0 0-358.4Z\" p-id=\"4426\" /><path d=\"M460.8 256l0 512L256 768 256 256 460.8 256M512 204.8 204.8 204.8l0 614.4 307.2 0L512 204.8 512 204.8z\" p-id=\"4427\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol